import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// API Integrations used to have their own wizard and list page. They now live
// inside the Marketplace (Create New and My Creations); these keep old links
// and bookmarks working.

export const LegacyNewIntegrationRedirect: React.FC = () => (
  <Navigate replace to="/tools-marketplace?view=create&type=integration&step=import" />
);

export const LegacyEditIntegrationRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate replace to={`/tools-marketplace?view=create&type=integration&id=${encodeURIComponent(id ?? '')}&step=endpoints`} />;
};

export const LegacyIntegrationListRedirect: React.FC = () => (
  <Navigate replace to="/tools-marketplace?view=creations&type=integration" />
);
